import { Button } from "@mui/material";

import styled from "styled-components";

export const LoginButtonStyled = styled(Button)`
    border: 0 !important;
    padding: 12px 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    min-width: initial !important;
    display: flex !important;
`;

export const BigqueryLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #1a73e8 !important;
    color: white !important;
`;

export const GoogleSheetsLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #ffff !important;
    color: #000000 !important;
    border: 2px solid #000000 !important;
`;

export const HubspotLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #ff7c00 !important;
    color: white !important;
`;

export const DynamicsLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #1a73e8 !important;
    color: #1a73e8 !important;
    background-color: #ffffff !important;
`;

export const SalesforceLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #00a2e1 !important;
    color: #00a2e1 !important;
    background-color: #ffffff !important;
`;

export const ZohoLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #729abf !important;
    color: white !important;
`;

export const MondayLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #00a0a0 !important;
    color: #00a0a0 !important;
    background-color: #ffffff !important;
`;

export const ZendeskLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #d9bd81 !important;
    color: white !important;
`;

export const PipedriveLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #017737 !important;
    color: white !important;
`;

export const B24LoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #0f578a !important;
    color: white !important;
`;

export const LinkedinLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #1a73e8 !important;
    color: #1a73e8 !important;
    background-color: #ffffff !important;
`;

export const TiktokLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #000000 !important;
    color: white !important;
`;

export const PinterestLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid red !important;
    color: red !important;
    background-color: #ffffff !important;
`;

export const RedditLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #ff4400 !important;
    color: #ff4400 !important;
`;

export const YandexLoginButtonStyled = styled(LoginButtonStyled)`
    background-color: #fc3f1d !important;
    color: white !important;

    &:hover {
        background-color: #e03618 !important;
    }
`;

export const MsofflineLoginButtonStyled = styled(LoginButtonStyled)`
    border: 2px solid #02897b !important;
    color: #02897b !important;
    background-color: #ffffff !important;
    transition:
        background-color 0.2s ease,
        color 0.2s ease,
        border-color 0.2s ease !important;

    &:hover {
        background-color: rgba(2, 137, 123, 0.08) !important;
        color: #027066 !important;
        border-color: #027066 !important;
    }
`;
